import { Component, Input } from '@angular/core';
import { Menu } from '../../core/models/menu.model';

@Component({
  selector: 'app-side-bar-desktop',
  templateUrl: './side-bar-desktop.component.html',
  styleUrl: './side-bar-desktop.component.scss'
})
export class SideBarDesktopComponent {

  @Input() menuData: Menu[] = [];

}
